import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import React, { useEffect, useState, useRef } from "react";
import {
  deleteErrands,
  getErrands,
  adddeliveredErrands,
} from "../../Data/Errands";
import { useReactToPrint } from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import ReactToPrint from "react-to-print";
import PrintCompoonet from "../../components/PrintCom";
import Button from "@material-ui/core/Button";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
const ErrandComponent = ({ items }) => {
  const [openMoreItems, setOpenMoreItems] = useState(false);
  const { data, id } = items;

  let name = data.user.name;
  let phone = data.user.phone;
  let email = data.user.email;
  let dateCreated = data.dateCreated;
  let title = data.title;
  let desc = data.description;

  const handleDeliveredErrands = ({ id }) => {
    adddeliveredErrands({
      user: data.user,
      err_title: title,
      err_desc: desc,
    })
      .then(() => {
        deleteErrands(id);
        return alert("Errands added to Delivered Errands");
      })
      .catch((e) => {
        return alert("Error:Item not added to delivered orders");
      });
  };

  return (
    <>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <PersonRoundedIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={`Name: ${name}`}
            secondary={`Date: ${dateCreated.toDate().toGMTString()}`}
          />
          <ListItemText
            primary={`Phone: ${phone}`}
            secondary={`Email: ${email}`}
          />

          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={async (_) => {
                deleteErrands(id);
                alert("Errand Deleted");
              }}
            >
              <DeleteIcon color="error" fontSize="large" />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={(_) => setOpenMoreItems(!openMoreItems)}
            >
              {openMoreItems ? (
                <ExpandLessRoundedIcon color="primary" fontSize="large" />
              ) : (
                <ExpandMoreRoundedIcon color="primary" fontSize="large" />
              )}
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>

        {openMoreItems ? (
          <ListItem key={id}>
            <ListItemText primary={`Title: ${title} `} secondary={`${desc}`} />
          </ListItem>
        ) : null}

        <center key={id}>
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={async (_) => {
                handleDeliveredErrands({ id: id });
              }}
            >
              Mark as delivered
            </Button>
          </div>
        </center>
      </List>

      <br />
      <br />
      <Divider dark />
    </>
  );
};

export default ErrandComponent;
